import ButtonCircle from '../ButtonCircle';

export interface FactBoxProps {
  imgSrc?: string;
  title?: string;
  copy?: string;
  url?: string;
}

const FactBox: React.FC<FactBoxProps> = ({ imgSrc, title, copy, url }) => {
  const inner = (
    <div className="fact-box__inner">
      {imgSrc && <img src={imgSrc} alt={title} width={112} height={112} />}
      <div className="fact-box__content">
        {title && <h2 className="fact-box__title">{title}</h2>}
        {copy && <p className="fact-box__copy">{copy}</p>}
      </div>
    </div>
  );

  if (url) {
    return (
      <a href={url} className="fact-box">
        {inner}

        <ButtonCircle
          extraClasses="button--primary"
          arrowFill="#FFFFFF"
          arrowHeight={40}
          arrowWidth={40}
        />
      </a>
    );
  }
  return <div className="fact-box">{inner}</div>;
};

export default FactBox;
